import React from 'react';
import { Scale } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const LitigationPage = () => {
  const serviceData = {
    icon: Scale,
    nameAr: 'دائرة التقاضي',
    nameEn: 'Litigation Department',
    taglineAr: 'تمثيل قانوني متميز أمام جميع الجهات القضائية',
    taglineEn: 'Distinguished legal representation before all judicial authorities',
    
    descriptionAr: [
      'تُعد دائرة التقاضي في وازن من أقوى الدوائر القانونية المتخصصة في تمثيل العملاء أمام المحاكم والجهات القضائية المختلفة في المملكة العربية السعودية. نقدم خدمات قانونية متكاملة تشمل جميع مراحل التقاضي من رفع الدعوى حتى تنفيذ الأحكام.',
      'يتمتع فريقنا بخبرة واسعة في الترافع أمام المحاكم العامة والمتخصصة، ونحرص على تقديم أفضل استراتيجيات الدفاع القانوني لضمان حقوق عملائنا وتحقيق أفضل النتائج الممكنة في القضايا المختلفة.'
    ],
    descriptionEn: [
      'Wazin\'s Litigation Department is one of the strongest specialized legal departments in representing clients before courts and various judicial authorities in Saudi Arabia. We provide comprehensive legal services covering all stages of litigation from filing the case to executing judgments.',
      'Our team has extensive experience in pleading before general and specialized courts, and we are committed to providing the best legal defense strategies to ensure our clients\' rights and achieve the best possible results in various cases.'
    ],

    services: [
      {
        nameAr: 'رفع صحائف الدعاوى أمام الجهات القضائية المختصة',
        nameEn: 'Filing lawsuits before competent judicial authorities',
        descAr: 'إعداد وتقديم صحائف الدعاوى بمختلف أنواعها أمام المحاكم والجهات القضائية المختصة وفقاً للإجراءات النظامية',
        descEn: 'Preparing and submitting lawsuits of all types before courts and competent judicial authorities in accordance with legal procedures'
      },
      {
        nameAr: 'إعداد لوائح الاعتراض على الأحكام (استئناف / نقض / التماس إعادة نظر)',
        nameEn: 'Preparing objection petitions (appeal / cassation / review)',
        descAr: 'صياغة وتقديم لوائح الاعتراض على الأحكام الصادرة في مختلف مراحل التقاضي',
        descEn: 'Drafting and submitting objection petitions against judgments issued at various stages of litigation'
      },
      {
        nameAr: 'المرافعة أمام المحاكم بمختلف درجاتها',
        nameEn: 'Pleading before courts of all levels',
        descAr: 'تقديم المرافعات الشفوية والدفوع القانونية أمام المحاكم الابتدائية والاستئنافية والعليا',
        descEn: 'Presenting oral pleadings and legal defenses before primary, appellate, and supreme courts'
      },
      {
        nameAr: 'حضور الجلسات القضائية وتمثيل العملاء',
        nameEn: 'Attending court hearings and representing clients',
        descAr: 'الحضور الشخصي في جميع الجلسات القضائية والمرافعة نيابة عن العملاء',
        descEn: 'Personal attendance at all court hearings and pleading on behalf of clients'
      },
      {
        nameAr: 'تقديم المذكرات القانونية والردود النظامية',
        nameEn: 'Submitting legal briefs and regulatory responses',
        descAr: 'إعداد وتقديم المذكرات القانونية والردود التفصيلية على دعاوى الخصوم',
        descEn: 'Preparing and submitting legal briefs and detailed responses to opponents\' claims'
      },
      {
        nameAr: 'إدارة ملف القضية كاملاً من القيد حتى التنفيذ أو الإغلاق',
        nameEn: 'Complete case file management from registration to execution or closure',
        descAr: 'إدارة شاملة لملف القضية تشمل جميع المراحل من التسجيل والمتابعة حتى التنفيذ النهائي',
        descEn: 'Comprehensive case file management covering all stages from registration and follow-up to final execution'
      },
      {
        nameAr: 'تقديم الاستئناف على الأحكام الابتدائية',
        nameEn: 'Filing appeals against primary judgments',
        descAr: 'إعداد وتقديم لوائح الاستئناف على الأحكام الابتدائية وفق الإجراءات والمواعيد النظامية',
        descEn: 'Preparing and filing appeal petitions against primary judgments according to procedures and legal deadlines'
      },
      {
        nameAr: 'تقديم الاعتراضات أمام الجهات القضائية المختصة',
        nameEn: 'Filing objections before competent judicial authorities',
        descAr: 'تقديم الاعتراضات والطعون على القرارات والأحكام أمام الجهات المختصة',
        descEn: 'Filing objections and appeals against decisions and judgments before competent authorities'
      },
      {
        nameAr: 'رفع طلبات التنفيذ القضائي ومتابعتها',
        nameEn: 'Filing and following up execution requests',
        descAr: 'تقديم طلبات التنفيذ لدى محاكم التنفيذ ومتابعتها حتى استيفاء الحقوق كاملة',
        descEn: 'Submitting execution requests to execution courts and following them up until full rights are obtained'
      },
      {
        nameAr: 'تقديم طلبات وقف التنفيذ عند توافر شروطه',
        nameEn: 'Filing stay of execution requests when conditions are met',
        descAr: 'إعداد وتقديم طلبات وقف التنفيذ مع المستندات والأسباب النظامية المطلوبة',
        descEn: 'Preparing and filing stay of execution requests with required documents and legal grounds'
      },
      {
        nameAr: 'الترافع في الطعون الإدارية على القرارات الحكومية',
        nameEn: 'Pleading in administrative appeals against government decisions',
        descAr: 'تمثيل العملاء في الطعون الإدارية أمام ديوان المظالم والجهات المختصة',
        descEn: 'Representing clients in administrative appeals before Board of Grievances and competent authorities'
      },
      {
        nameAr: 'متابعة الإشعارات والمراسلات القضائية إلكترونياً',
        nameEn: 'Following up notifications and court correspondence electronically',
        descAr: 'متابعة يومية للإشعارات والمراسلات القضائية عبر المنصات الإلكترونية الرسمية',
        descEn: 'Daily follow-up of notifications and court correspondence through official electronic platforms'
      },
      {
        nameAr: 'التفاوض والصلح في القضايا قبل وأثناء سير الدعوى',
        nameEn: 'Negotiation and settlement in cases before and during proceedings',
        descAr: 'إجراء مفاوضات مع الأطراف للوصول إلى تسويات ودية تحقق مصلحة العميل',
        descEn: 'Conducting negotiations with parties to reach amicable settlements serving client interests'
      },
      {
        nameAr: 'إعداد تقارير دورية لسير القضايا لعرضها على العميل أو الإدارة',
        nameEn: 'Preparing periodic reports on case progress for clients or management',
        descAr: 'إعداد تقارير شاملة ودورية توضح مستجدات القضية والخطوات التالية',
        descEn: 'Preparing comprehensive periodic reports showing case developments and next steps'
      }
    ],

    specializations: [
      { ar: 'القضايا التجارية والعقود', en: 'Commercial Cases and Contracts' },
      { ar: 'القضايا العمالية', en: 'Labor Cases' },
      { ar: 'القضايا العقارية', en: 'Real Estate Cases' },
      { ar: 'قضايا الشركات', en: 'Corporate Cases' },
      { ar: 'المنازعات المالية', en: 'Financial Disputes' },
      { ar: 'قضايا التنفيذ', en: 'Execution Cases' },
      { ar: 'القضايا الجزائية', en: 'Criminal Cases' },
      { ar: 'قضايا الأسرة والأحوال الشخصية', en: 'Family and Personal Status Cases' },
      { ar: 'المنازعات الإدارية', en: 'Administrative Disputes' },
      { ar: 'قضايا التعويضات', en: 'Compensation Cases' }
    ],

    faqs: [
      {
        questionAr: 'كم يستغرق رفع الدعوى القضائية؟',
        questionEn: 'How long does it take to file a lawsuit?',
        answerAr: 'عادةً يستغرق إعداد وتقديم الدعوى من 3 إلى 7 أيام عمل، حسب طبيعة القضية وتعقيدها. نحرص على سرعة الإجراءات مع الحفاظ على جودة العمل القانوني.',
        answerEn: 'Usually, preparing and filing a lawsuit takes 3 to 7 business days, depending on the nature and complexity of the case. We ensure speed of procedures while maintaining the quality of legal work.'
      },
      {
        questionAr: 'ما هي تكلفة رفع قضية؟',
        questionEn: 'What is the cost of filing a case?',
        answerAr: 'تختلف التكلفة حسب نوع القضية ودرجة تعقيدها. نقدم استشارة أولية مجانية لتقييم القضية وتحديد التكلفة المتوقعة. يمكنكم التواصل معنا للحصول على عرض سعر مفصل.',
        answerEn: 'The cost varies depending on the type of case and its complexity. We provide a free initial consultation to assess the case and determine the expected cost. You can contact us for a detailed quote.'
      },
      {
        questionAr: 'هل تقدمون خدمات التقاضي في جميع المحاكم؟',
        questionEn: 'Do you provide litigation services in all courts?',
        answerAr: 'نعم، نقدم خدمات التقاضي أمام جميع المحاكم السعودية بما في ذلك المحاكم العامة، التجارية، العمالية، الإدارية، والجزائية.',
        answerEn: 'Yes, we provide litigation services before all Saudi courts including general, commercial, labor, administrative, and criminal courts.'
      },
      {
        questionAr: 'ما الفرق بين الاستئناف والنقض؟',
        questionEn: 'What is the difference between appeal and cassation?',
        answerAr: 'الاستئناف هو الطعن في الحكم الابتدائي أمام محكمة الاستئناف، بينما النقض (التمييز) هو الطعن في حكم الاستئناف أمام المحكمة العليا. لكل منهما مواعيد نظامية محددة يجب الالتزام بها.',
        answerEn: 'Appeal is challenging the first-instance judgment before the Court of Appeal, while cassation is challenging the appellate judgment before the Supreme Court. Each has specific legal deadlines that must be adhered to.'
      },
      {
        questionAr: 'هل يمكنني متابعة قضيتي إلكترونياً؟',
        questionEn: 'Can I follow my case electronically?',
        answerAr: 'نعم، نوفر بوابة إلكترونية متطورة لعملائنا تتيح لهم متابعة جميع تفاصيل قضاياهم، مواعيد الجلسات، المستندات، والتحديثات الفورية على مدار الساعة.',
        answerEn: 'Yes, we provide an advanced electronic portal for our clients that allows them to follow all details of their cases, hearing dates, documents, and real-time updates 24/7.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default LitigationPage;
